import dayjs from 'dayjs';
import { Call } from '@/types/call';

export const compareCallsByTimeDesc = (a: Call, b: Call): number =>
  dayjs(b.placedAt).isBefore(dayjs(a.placedAt)) ? -1 : 1;
